"use client";

import { createContext, useContext, useMemo } from "react";

const PortalContext = createContext(null);

export function PortalProvider({ portal, children }) {
  const value = useMemo(() => {
    if (!portal || portal.unavailable) return portal || null;
    return {
      ...portal,
      allowedHubSlugSet: new Set(portal.allowedHubSlugs || []),
    };
  }, [portal]);

  return <PortalContext.Provider value={value}>{children}</PortalContext.Provider>;
}

export function usePortal() {
  return useContext(PortalContext);
}

export function isHubAllowedInPortal(portal, hubSlug) {
  if (!portal || portal.unavailable) return !portal;
  return portal.allowedHubSlugSet?.has(String(hubSlug || "")) || false;
}
